var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-screen h-screen fixed left-0 top-0 bg-black flex items-center justify-center bg-opacity-40 z-100"},[_c('loading-spinner',{attrs:{"is-loading":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }